<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  /*provide():{
    return{
        reload:this.reload
  }
  }*/
}
</script>

<style>
#app {
  position: absolute;
  left: 0;
  top:0;
  width:100vw;
  height:100vh;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/App.vue